/**
 * Location Keywords Field
 *
 * @author Madhu Jayakumar (madhu@yext.com)
 */
goog.module('yext.location.keywords');
goog.module.declareLegacyNamespace();

const helpers = goog.require('yext.location.helpers');
const routes = goog.require('yext.storm.routes');


/**
 * Keywords class
 * @constructor
 */
var Keywords = function($element) {
  this.$element = $element;
  this.$keywords = $element.find('.options-list');

  this.storedValues = {};
  this.storedValues.options = [];
  this.storedValues.customs = [];

  this.bindKeywords();
  this.storeValues();
};

/**
 * Broadcast a message that can be captured
 *
 * @param {string} message The message to be published
 */
Keywords.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Removes custom values that are not checked and validates that
 * the number of checked options is within the value-limit of the keyword field.
 */
Keywords.prototype.validateSubmit = function() {
  this.$element.find('.custom-row-checkbox').each(function() {
    $(this).val('');
    if (!$(this).prop('checked')) {
      $(this).parent().remove();
    }
  });
  return true;
};

/**
 * Binds the keywords form elements
 */
Keywords.prototype.bindKeywords = function() {
  var self = this;

  this.$element.on('click', '.js-keyword-delete', function() {
    $(this).parent().remove();
    self.message('updated');
  });

  this.$element.find('.js-reset-field').click(function() {
    $(this)
      .closest('.js-keywords-field')
      .find('input')
      .each(function() {
        $(this).prop('checked', false);
      });
    self.message('updated');
  });

  this.$element.find('.reset-show-options').click(function() {
    $(this)
      .closest('.js-keywords-field')
      .find('.show-edit-options')
      .show();
    $(this).parent().hide();
  });

  this.$element.on('click', 'input', function() {
    self.message('updated');
  });

  var $hiddenCustom = self.$element.find('.new-custom-hidden');

  this.$element.on('click', '.add-custom-value', function() {
    var $newCustomValue = $hiddenCustom.clone();
    var sectionId = self.$element
      .parent()
      .find('[name=keyword-section-id]')
      .val();
    var fieldId = self.$element
      .parent()
      .find('[name=keyword-field-id-' + sectionId + ']')
      .val();

    $newCustomValue.removeClass('new-custom-hidden hidden-custom');

    if ($newCustomValue.find('.custom-check-box').attr('type') === 'radio') {
      self.$element.find('.js-reset-field').click();
    }

    $newCustomValue.find('.custom-check-box')
      .addClass('custom-row-checkbox')
      .prop('checked', true);

    self.$element.find('.options-list li:eq(-2)').after($newCustomValue);

    if ($newCustomValue.find('.custom-check-box').attr('type') === 'radio') {
      $newCustomValue
        .find('.custom-check-box')
        .attr('name', sectionId + '-' + fieldId);
    }

    $newCustomValue
      .find('.custom-input-box')
      .attr('name', 'custom-value-' + sectionId + '-' + fieldId)
      .focus();

    $newCustomValue.find('.custom-input-box').keypress(function() {
      self.message('updated');
    });
  });
};

/**
 * Create a keywords field object
 * @param {!jQueryElement} $element The container for the edit view of keywords
 * @param {Keywords} Keyword Field model
 */
function create($element) {
  return new Keywords($element);
}

/**
 * Re-renders the display mode with the data from ajax call.
 * @param {!Object} data The response including the new selected options
 */
Keywords.prototype.renderViewMode = function(data) {
  if (!data.field) {
    return;
  }

  var keywordValues = [];
  data.field.options.forEach(function(option) {
    if (option.selected) {
      keywordValues.push(option.label);
    }
  });
  data.field.customValues.forEach(function(customValue) {
    keywordValues.push(customValue);
  });

  if (keywordValues.length === 0) {
    return helpers.emptyFieldMessage();
  }
  var $list = $('<ul>', {'class': 'keywords-list'});
  keywordValues.forEach(function(value) {
    $list.append($('<li>', {text: value}));
  });
  return $list;
};

/**
 * Store the searcher values so they can be restored with the reset method
 */
Keywords.prototype.storeValues = function() {
  var storedValues = this.storedValues = {};
  storedValues.options = [];
  storedValues.customs = [];

  this.$element.find('li.option').each(function() {
    storedValues.options.push($(this).clone(true));
  });

  this.$element.find('li.custom').each(function() {
    storedValues.customs.push($(this).clone(true));
  });
};

/**
 * Reset the keywords to the state stored in storedValues
 */
Keywords.prototype.reset = function() {
  this.clearKeywords();
  this.$keywords.empty();

  var field = this.storedValues;
  var $list = this.$element.find('.options-list');

  for (var i = 0; i < field.options.length; i++) {
    $list.append(field.options[i]);
  }

  for (var i = 0; i < field.customs.length; i++) {
    $list.append(field.customs[i]);
  }

  this.storeValues();
};

/**
 * Cleanup to unbind keyword events
 */
Keywords.prototype.clearKeywords = function() {
  this.$element.find('li.option').each(function() {
    $(this).off();
  });

  this.$element.find('li.custom').each(function() {
    $(this).off();
  });
};

/**
 * Keyword section class
 * @constructor
 */
var KeywordSection = function($element) {
  this.reset($element);
};

/**
 * Initializes the section.
 */
KeywordSection.prototype.reset = function($element) {
  this.$element = $element;
  this.model = $element.data('model');
  this.$fields = this.$element.find('.js-keywords-field');
  this.fields = [];
  this.bindFields();
};

/**
 * Bind individual keyword fields that comprise this section.
 */
KeywordSection.prototype.bindFields = function() {
  var section = this;
  this.$fields.each(function() {
    section.fields.push(create($(this)));
  });
};

/**
 * Updates the section to reflect fields appropriate for a new primary category.
 */
KeywordSection.prototype.switchCategory = function(categoryId) {
  var args = {
    'categoryId': categoryId,
    'sectionId': this.model.id,
    'locationIds': this.model.locationIds,
    'templateId': this.model.templateId,
  };
  var self = this;
  return $.get(routes.LocationEdit.getCategoryKeywordsForm(args))
    .then(function(result) {
      self.render(result.html);
    });
};

/**
 * Replaces the contents of the section with the given HTML string and resets the section.
 */
KeywordSection.prototype.render = function(html) {
  var $newElement = $(html);
  this.$element.replaceWith($newElement);
  this.reset($newElement);
};

exports = {
  create,
  Keywords,
  KeywordSection,
};
